import { Suspense, lazy } from 'react';

import { KDErrorBoundary } from '@/components';
import { KDLayoutDashboardLoader } from '@/layouts';

const OrdersPage = lazy(() => import('./Orders.page'));

export const Orders = () => {
  return (
    <KDErrorBoundary>
      <Suspense fallback={<KDLayoutDashboardLoader />}>
        <OrdersPage />
      </Suspense>
    </KDErrorBoundary>
  );
};
